export const generateFaqLink = (locale) => {
  let faqLocale: string;

  switch (locale) {
    case 'en-GB':
    case 'en-US':
      faqLocale = 'en-001';
      break;
    case 'fr-FR':
      faqLocale = 'fr';
      break;
    default:
      faqLocale = 'de';
  }

  return `https://support.femtasy.com/hc/${faqLocale}`;
};
